const useShowNewHomepage = () => {
  const showNewHomepage = false;

  return {
    showNewHomepage,
  };
};

export default useShowNewHomepage;
